export default "__VITE_ASSET__gOpBNSELCNdnM_yZlyA5OQ__";